import Button from "@/common/components/Button";
import Modal from "@/common/components/Modal";
import { ModalMessageSimple } from "@/common/components/ModalMessageSimple";
import { useState } from "react";
import { useClientUserResetDriverAppPin } from "../hooks/useClientUserResetDriverAppPin";

const ResetDriverAppPin = ({ id }: { id: string; }) => {
  const [isOpen, setIsOpen] = useState(false);

  const [messages, setMessages] = useState<string[] | boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);

  const { mutate: requestResetDriverAppPin, isPending: requestResetDriverAppPinIsPending } = useClientUserResetDriverAppPin({
    userId: id,
    onSuccess: () => {
      setIsOpen(false);
      setIsError(false);
      setMessages(['PIN Enviado ao condutor.']);
    },
    onError: (error) => {
      setIsOpen(false);
      setIsError(true);
      setMessages((error.response?.data as { errors: { base: string[]; }; })?.errors?.base || null);
    },
  });

  return (
    <>
      <Modal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        Trigger={
          <Button name="reset_driver_app_pin" disabled={requestResetDriverAppPinIsPending}>
            Redefinir PIN
          </Button>
        }
        useCancellableFooter
        showClose={false}
        title="Você deseja realmente alterar o PIN?"
        subtitle="Ao clicar em confirmar, o PIN anterior do usuário será desativado."
        subtitleClassName="mt-1 text-md text-white-300"
        confirmButtonClassName="bg-blue-700"
        onConfirm={() => requestResetDriverAppPin()}
      />

      {messages && (
        <ModalMessageSimple
          messages={messages}
          setMessages={setMessages}
          isError={isError}
        />
      )}
    </>
  );
};

export default ResetDriverAppPin;
